import { useRef, forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

export const SelectedTemplate = forwardRef(
  ({ onClearTemplate, persistentData }, ref) => {
    const { t } = useTranslation(["CreateTaskModal"]);
    const componentRef = useRef();
    const [currentTemplate, setCurrentTemplate] = useState(
      persistentData ?? null
    );

    useImperativeHandle(
      ref,
      () => ({
        setCurrentTemplate,
        getCurrentTemplate: () => currentTemplate,
      }),
      [componentRef, currentTemplate]
    );

    return (
      <div className="d-flex justify-content-start gap-2 bg-et-lightest-gray p-2 br-4">
        <span className="fw-600 fs-12">{t("SelectedTemplate")}</span>
        {currentTemplate ? (
          <div className="d-flex justify-content-between align-items-center gap-2 bg-light-green-1 br-100 fs-12 fw-600 px-2 shadow-sm">
            <div> {currentTemplate?.Name}</div>
            <i
              className="clear-template-icon fa-regular fs-12 et-black fa-xmark cursor-pointer"
              onClick={onClearTemplate}
            />
          </div>
        ) : (
          <div className="et-darkest-gray fw-400 fs-12">{t("None")}</div>
        )}
      </div>
    );
  }
);
